// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"731":"dcf0ca31","4028":"07b27d5b","8505":"a8e93dfb","9161":"247d35ab"}[chunkId] + ".chunk.css";
};